export const EventsSponsorsData =[
    {
        "Title":"ONGC",
        "Image": require("../assets/sponsors/ONGC.jpg"),
        "Description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        "Link":"",

    },
    {
        "Title":"Tea Post",
        "Image": require("../assets/sponsors/tea-post.jpg"),
        "Description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        "Link":"",

    },
    {
        "Title":"JB Sports",
        "Image": require("../assets/sponsors/jb-sports.jpg"),
        "Description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        "Link":"",

    },
    {
        "Title":"Friends Group",
        "Image": require("../assets/sponsors/friends-group.jpg"),
        "Description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        "Link":"",

    },
]